// extracted by mini-css-extract-plugin
export default {"container":"SeriesRow_container__EMVJf"};